import { FormExtractorService } from '../../../../shared/services/form-extractor.service';
import { LogService } from '../../../../shared/services/log.service';
import { Validator } from '../../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../../ctrl.name.extractor';

export class CTRL_299 implements Validator {

    public static id = 'CTRL_299';
    private message = 'error.ctr_299';


    public LOG: LogService = new LogService(CTRL_299);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_299.id + '_');

        if (rgs.length > 0) {
            for (const rg of rgs) {
                const ctrl = form.controls[rg];
                const critereNameWithStepId = map.get(ctrl.value.rgCtrls.critere);
                const poidsNameWithStepId = map.get(ctrl.value.rgCtrls.poids);
                const critereCtrl = form.controls[critereNameWithStepId];
                const poidsCtrl = form.controls[poidsNameWithStepId];

                if (critereCtrl.value !== '' && poidsCtrl.value === '') {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}
